import AccessibilityIcon from '@material-ui/icons/Accessibility';
import UserManual from './List/List';
import { UserManualCreate } from './Create/Create';

export const userManualResource = {
	list: UserManual,
	icon: AccessibilityIcon,
    create: UserManualCreate,
}
